exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pendingTaskNotice{pointer-events:none;transition:opacity .9s}.pendingTaskNotice .innerBanner{position:fixed;top:68px;left:-60px;z-index:900010;width:300px;height:36px;background-color:#e46e36;transform:rotate(-45deg)}.pendingTaskNotice p{position:relative;top:7px;z-index:200;text-align:center;color:#fff}.pendingTaskNotice.fadeOut{opacity:0}.pendingTaskNotice .fadeCycle{animation:fadeAnimation 2s infinite ease-in-out}@keyframes fadeAnimation{0%{opacity:.8}50%{opacity:.5}to{opacity:.8}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/layout/pending_task_notice.scss
// module id = 1338
// module chunks = 0